var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CSearchSelectSortSingleValue } from '@/components/modules/pages/consultantSearch/Form/CSearchSelectSort/CSearchSelectSortSingleValue';
import { Select } from '@/components/ui/Form/Select';
import { Tooltip } from '@/components/ui/Tooltip/Tooltip';
/**
 * コンサルサーチ：ソート用のセレクトボックス
 * @param props
 * @constructor
 */
export const CSearchSelectSort = (props) => {
    const { className = '', disabled, onClickDisabled, options } = props, otherProps = __rest(props, ["className", "disabled", "onClickDisabled", "options"]);
    return (_jsx(Tooltip, Object.assign({ arrow: true, className: className, html: disabled ? _jsx("span", { children: '会員の方のみ利用可能' }) : undefined, isUnderHeaderComponent: true, position: 'top', zIndex: 0 }, { children: _jsx("div", Object.assign({ className: 'w-full cursor-pointer', onClick: disabled ? onClickDisabled : undefined, role: 'presentation' }, { children: _jsx(Select, Object.assign({ components: { SingleValue: CSearchSelectSortSingleValue }, disabled: disabled, options: options }, otherProps)) })) })));
};
